import { KickerLine } from "@motleyhand/design"

export default function Terms() {
  return (
    <section className="mx-auto max-w-3xl px-6 py-6 sm:py-8">
      <KickerLine
        className="justify-center text-sm"
        items={[
          "Free to start",
          "Bring your API keys",
          "Scale when you’re ready",
        ]}
      />
    </section>
  )
}
